
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"savePollConfiguration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ConfigurationInput"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveConfiguration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"data"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"photos"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"visualIdentity"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"slider"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"project"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sourceOfProjects"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"selectedContestId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"listOfSelectedProjects"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"configuration"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicationDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"deadlineForVotingOnProjects"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"to"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"customLink"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"projectDataForDisplay"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entrepreneurName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"entrepreneurAbout"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"entrepreneurFoundedOn"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"entrepreneurType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nameOfProject"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"questions"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"projectStatus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"idwall_status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"proposedValue"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"approvedValue"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fundingSource"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"actingLocations"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"targetsAudience"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"movies"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sites"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"complementaryFiles"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ods"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"areasOfInterest"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"subareasOfInterest"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"socialNetwork"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"evaluation"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"scoreAsPrivate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"voteLimitPerEmail"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"votingRestrictionByEmail"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"isDraft"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":1077}};
    doc.loc.source = {"body":"mutation savePollConfiguration( $input: ConfigurationInput! ) {\n  saveConfiguration( input: $input ) {\n    id\n    data {\n      pageType\n      name\n      description\n      photos {\n        visualIdentity\n        slider\n      }\n    }\n    project {\n      sourceOfProjects\n      selectedContestId\n      listOfSelectedProjects\n    }\n    configuration {\n      publicationDate\n      deadlineForVotingOnProjects {\n        from\n        to\n      }\n      customLink\n      projectDataForDisplay {\n        entrepreneurName\n        entrepreneurAbout\n        entrepreneurFoundedOn\n        entrepreneurType\n        nameOfProject\n        description\n        questions\n        projectStatus\n        idwall_status\n        proposedValue\n        approvedValue\n        fundingSource\n        actingLocations\n        targetsAudience\n        movies\n        sites\n        complementaryFiles\n        ods\n        areasOfInterest\n        subareasOfInterest\n        socialNetwork\n        evaluation\n      }\n      scoreAsPrivate\n      voteLimitPerEmail\n      votingRestrictionByEmail\n    }\n    isDraft\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["savePollConfiguration"] = oneQuery(doc, "savePollConfiguration");
        



//////////////////
// WEBPACK FOOTER
// ./src/graphql/savePollConfiguration.gql
// module id = rSra
// module chunks = 1